import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgFeedback = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M4.746 15.886a.8.8 0 0 1-.42.114q-.331 0-.512-.213-.174-.206-.173-.554v-2.058h-.297q-1.047 0-1.798-.39a2.77 2.77 0 0 1-1.149-1.137Q0 10.902 0 9.845V4.336Q0 3.28.397 2.54a2.7 2.7 0 0 1 1.149-1.142Q2.304 1 3.395 1h9.21q1.09 0 1.842.398.758.398 1.156 1.142Q16 3.28 16 4.336v5.51q0 1.056-.397 1.802-.397.739-1.156 1.136-.75.39-1.842.39H7.866l-2.65 2.358q-.276.247-.47.354M4 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFeedback);
export default ForwardRef;
